// extracted by mini-css-extract-plugin
export default {"inplace-edit-display-container":"TextInplaceEdit_inplace-edit-display-container__qkRsJ"};